import type { RouteRecordRaw } from 'vue-router'
import { AppModule } from '@/config/types'
import { FormsRoutes } from '@/routes/user/forms/types'
import { getFormsDetailsRoutes } from '@/routes/user/forms/formsDetails'

export const getFormsRoutes = (): RouteRecordRaw[] => [
  {
    name: FormsRoutes.index,
    path: 'forms',
    meta: {
      permission: 'subscribeForms',
      modules: [AppModule.ContactList, AppModule.WidgetSubscribe, AppModule.WidgetClickToText],
    },
    component: () => import('@/components/views/services/forms/FormViewNew.vue'),
    redirect: { name: FormsRoutes.subscribe },
    children: [
      {
        name: FormsRoutes.subscribe,
        path: 'subscribe',
        component: () => import('@/components/views/services/forms/FormSubscribeView.vue'),
        meta: {
          tabTitle: 'pageTabTitle.user.services.forms.subscribeForms',
        },
      },
      {
        name: FormsRoutes.clickToText,
        path: 'click-to-text',
        component: () => import('@/components/views/services/forms/FormClickToTextView.vue'),
        meta: {
          tabTitle: 'pageTabTitle.user.services.forms.clickToTextForms',
        },
      },
    ],
  },
  ...getFormsDetailsRoutes(),
]
